import axios from 'axios';
import { BACKEND_API_URL, API_ENDPOINTS } from '@/config/endpoints';
import type { CsvConfig, ExportRequest, ExportResponse } from '@/types/export';

export async function requestExport(
  subscriptionId: string,
  address: string,
  startDate: string,
  endDate: string,
  csvConfig: CsvConfig,
): Promise<ExportResponse> {
  const payload: ExportRequest = {
    subscription_id: subscriptionId,
    address,
    start_date: startDate,
    end_date: endDate,
    csv_config: csvConfig,
  };

  const response = await axios.post<ExportResponse>(
    `${BACKEND_API_URL}${API_ENDPOINTS.EXPORT_REQUEST}`,
    payload,
  );

  return response.data;
}
